import React from 'react';
import Modal from 'components/Modal';
import { gql } from '@apollo/client';
import { useMutation, useQuery } from 'hooks/apollo';
import Table from 'components/Table';
import LanguageTag from 'components/LanguageTag';
import { DeviceType } from 'shared/services/prisma/types';

const QUERY = gql`
  query($surveyGroupId: ID!, $websiteId: ID!) {
    surveyMigration(surveyGroupId: $surveyGroupId, websiteId: $websiteId)
  }
`;

const MUTATION = gql`
  mutation($surveyGroupId: ID!, $websiteId: ID!) {
    migrateSurvey(surveyGroupId: $surveyGroupId, websiteId: $websiteId)
  }
`;

const MigrateSurvey = ({ open, onCancel, onDone, surveyGroup, website }) => {
  const { data, loading } = useQuery(QUERY, {
    variables: { surveyGroupId: surveyGroup?.id, websiteId: website?.id },
    skip: !surveyGroup,
    fetchPolicy: 'network-only',
  });

  const [migrateSurvey, { loading: migrating }] = useMutation(MUTATION, {
    variables: { surveyGroupId: surveyGroup?.id, websiteId: website?.id },
    onCompleted: onDone,
  });

  const dataSource = data?.surveyMigration?.surveys.map(s => ({
    ...s,
    desktop: s.dists.find(d => d.deviceTypes.includes(DeviceType.Desktop)),
    tablet: s.dists.find(d => d.deviceTypes.includes(DeviceType.Tablet)),
    mobile: s.dists.find(d => d.deviceTypes.includes(DeviceType.Mobile)),
    theme: s.dists.find(d => d).theme,
  }));

  const renderSetting = prop => dist => dist[prop];

  const columns = [{
    dataIndex: 'title',
    title: 'Survey',
  }, {
    dataIndex: 'language',
    title: 'Language',
    render: language => <LanguageTag language={language} />,
  }, {
    dataIndex: 'version',
    title: 'Version',
  }, {
    dataIndex: 'primary',
    title: 'Primary',
    type: 'bool',
  }, {
    title: 'Behavior',
    children: [{
      dataIndex: 'desktop',
      title: 'Desktop',
      render: renderSetting('behaviorSetting'),
    }, {
      dataIndex: 'tablet',
      title: 'Tablet',
      render: renderSetting('behaviorSetting'),
    }, {
      dataIndex: 'mobile',
      title: 'Mobile',
      render: renderSetting('behaviorSetting'),
    }],
  }, {
    title: 'Design',
    children: [{
      dataIndex: 'desktop',
      title: 'Desktop',
      render: renderSetting('designSetting'),
    }, {
      dataIndex: 'tablet',
      title: 'Tablet',
      render: renderSetting('designSetting'),
    }, {
      dataIndex: 'mobile',
      title: 'Mobile',
      render: renderSetting('designSetting'),
    }],
  }, {
    dataIndex: 'theme',
    title: 'Theme',
  }];

  return (
    <Modal
      title="Migrate survey"
      centered
      open={open}
      fullWidth
      onCancel={onCancel}
      okText="Migrate"
      onOk={migrateSurvey}
      confirmLoading={migrating}
    >
      <Table columns={columns} dataSource={dataSource} loading={loading} />
    </Modal>
  );
};

export default MigrateSurvey;
